import { apiClient } from "./apiClient";
import { setRenderMode } from "./renderModeFlag";

let interceptorId: number | null = null;
export const INTERNAL_RENDER_TOKEN_HEADER = "X-Internal-Render-Token";
export const INTERNAL_RENDER_ROUTES = {
  context: "/internal-render/context",
  attachments: "/internal-render/attachments",
  selectedImageUrl: "/internal-render/selected-image-url",
  selectedFileUrl: "/internal-render/selected-file-url",
} as const;
const DATA_GET_PATTERNS = [
  /^\/cases\/[^/]+\/document-view$/,
  /^\/cases\/[^/]+\/sign-off\/preview$/,
  /^\/workflows\/pathologist-review\/[^/]+\/pathologist-comments$/,
];

function acceptsRenderToken(method: string, url?: string): boolean {
  if (!url || /^https?:\/\//i.test(url)) return false;
  const path = url.split(/[?#]/, 1)[0];
  if (method === "get") {
    return (
      path === INTERNAL_RENDER_ROUTES.context ||
      path === INTERNAL_RENDER_ROUTES.attachments ||
      DATA_GET_PATTERNS.some((pattern) => pattern.test(path))
    );
  }
  if (method !== "post") return false;
  return (
    path === INTERNAL_RENDER_ROUTES.selectedImageUrl ||
    path === INTERNAL_RENDER_ROUTES.selectedFileUrl
  );
}

/**
 * Configures the global axios instance to authenticate approved renderer GETs
 * and the purpose-specific selected-image POST with a short-lived JWT. Used by
 * the headless Puppeteer route at
 * `/internal/render-report/:signOffId`.
 *
 * Pass `null` to remove the interceptor.
 */
export function setInternalRenderToken(token: string | null): void {
  if (interceptorId !== null) {
    apiClient.interceptors.request.eject(interceptorId);
    interceptorId = null;
  }

  setRenderMode(!!token);

  if (!token) return;

  interceptorId = apiClient.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    if (!acceptsRenderToken(method, config.url)) return config;

    config.headers.set(INTERNAL_RENDER_TOKEN_HEADER, token);
    delete config.headers.Authorization;
    delete (config.headers as any).common?.Authorization;
    return config;
  });
}
